import React, { useState, useEffect } from "react";
import "./login.css";
import { useNavigate } from 'react-router-dom';
import authService from '../../../services/auth.service';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { selectUserData } from '../../../redux/actions/login/loginSlice';

interface LoginForm {
  username: string;
  password: string;
  affilate: boolean;
}

const Login: React.FC = () => {
  const dispatch = useAppDispatch();
  const userState = useAppSelector(selectUserData);
  const navigate = useNavigate();
  
  const [form, setForm] = useState<LoginForm>({ 
    username: "", 
    password: "",
    affilate: true 
  });
  
  const [error, setError] = useState<string>("");

  // Check if already logged in
  useEffect(() => {
    if (authService.isAffiliateLoggedIn()) {
      navigate('/affilate');
    }
  }, [navigate]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    setError(""); // Clear any previous errors
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");

    try {
      const response = await authService.loginAffilate(form);

      if (response.status === 201 && response.data.data) {
        // Auth service will handle token storage
        navigate('/affilate');
      } else {
        setError("Invalid login response");
      }
    } catch (err) {
      setError("Login failed. Please check your credentials.");
      console.error('Login error:', err);
    }
  };

  return (
    <div className="affilate-login-page">
      <img src="/logo.png" alt="Logo" className="page-logo" />

      <div className="login-container">
        <form onSubmit={handleSubmit} className="login-form">
          <h2>Affiliate Login</h2>

          {error && <div className="error-message">{error}</div>}

          <input
            type="text"
            name="username"
            placeholder="Email"
            value={form.username}
            onChange={handleChange}
            required
          />

          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
          />

          <button 
            type="submit" 
            disabled={!form.username || !form.password}
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;